const state = {
  dadosFechamento: Array
}

const mutations = {
  setFechamentoAtual (state, obj) {
    state.dadosFechamento = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/fechamentoAtual.js